<template>
  <!-- 国内机票条款规则 -->
  <div class="changClause_box content_table">
    <p class="changClause_box_title">(仅供参考！请以航空公司为准)</p>
    <table width="100%" v-if="ruleText.length">
      <tr v-for="(item,index) in ruleText" :key="index">
        <th v-if="index===0" width="60px"></th>
        <th v-for="(rule,ruleIndex) in item" :key="ruleIndex" v-if="index == 0">
          <p v-if="rule.ruleTime.indexOf('>')>=0">
            起飞前
            {{parseInt(rule.ruleTime.split('>')[1])>24?
            (parseInt(rule.ruleTime.split('>')[1])/24)+'天':rule.ruleTime.split('>')[1]+'小时'}}（含）外
          </p>
          <p v-else-if="rule.ruleTime.indexOf('-')>=0&&rule.ruleTime.indexOf('统一')===-1">
            起飞前{{parseInt(rule.ruleTime.split('-')[0])>24?
            parseInt(rule.ruleTime.split('-')[0])/24+'天':rule.ruleTime.split('-')[0]+'小时'}}(含)外至
            {{parseInt(rule.ruleTime.split('-')[1])>24?
            parseInt(rule.ruleTime.split('-')[1])/24+'天':rule.ruleTime.split('-')[1]+'小时'}}(不含)外
          </p>
          <p v-else>{{rule.ruleTime}}</p>
        </th>
      </tr>
      <tr v-for="(sItem,sIndex) in ruleText" :key="'s'+sIndex">
        <td v-if="sIndex===0">退票</td>
        <td v-if="sIndex===1">改签</td>
        <td v-for="(sRule,sRuleIndex) in sItem" :key="sRuleIndex">
          <p>{{sRule.rateText}}</p>
        </td>
      </tr>
    </table>
    <table v-else width="100%">
      <tr>
        <th></th>
        <th>统一起飞前/后</th>
      </tr>
      <tr>
        <td>退票</td>
        <td>依据产品规则执行</td>
      </tr>
      <tr>
        <td>改签</td>
        <td>依据产品规则执行</td>
      </tr>
    </table>
    <p class="changClause_box_text">
      行李信息:
      <span style="color:#666">{{luggage||'-------'}}</span>
    </p>
  </div>
</template>
<script>
export default {
  name: "ChangClause",
  data() {
    return {
      loading: true
    };
  },
  methods: {},
  props: ["ruleText", "luggage"],
  created() {}
};
</script>
<style lang="less" scoped>
.changClause_box {
  padding: 10px 10px 0 10px;
  width: 100%;
  &_title {
    color: red;
    text-align: left;
  }
  &_text {
    text-align: justify;
    line-height: 25px;
  }
}
.content_table {
  table {
    margin: auto;
    margin: 20px 0 0 0;
    border-collapse: collapse;
    th {
      font-size: 13px;
      padding: 5px;
      text-align: center;
    }
    td {
      text-align: center;
      word-break: break-word;
      padding: 5px;
      font-size: 12px;
    }
  }
  table td,
  table th {
    border: 1px solid #cad9ea;
    color: #666;
    height: 30px;
  }
}
</style>

